import { useEffect, useState } from "react";
import { Reveal, SectionLabel } from "@/components/site/bits";
import { api } from "@/lib/api";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/blog").then(({ data }) => setPosts(data)).catch(() => {}); }, []);
  if (!posts.length) return null;

  return (
    <section id="blog" className="relative py-28 px-6" data-testid="blog">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <SectionLabel>Insights & Blog</SectionLabel>
          <h2 className="font-display text-4xl md:text-5xl font-bold tracking-tight">
            Ideas from the <span className="text-gradient">AI frontier</span>
          </h2>
        </Reveal>
        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {posts.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.08}>
              <motion.button whileHover={{ y: -6 }} onClick={() => setOpen(p)} data-testid={`blog-card-${p.id}`}
                className="group h-full text-left overflow-hidden rounded-2xl glass hover:border-[#00E5FF]/40">
                <div className="relative aspect-[16/10] overflow-hidden">
                  {p.image ? (
                    <img src={p.image} alt={p.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  ) : (
                    <div className="h-full w-full bg-gradient-to-br from-[#00E5FF]/20 to-[#7B61FF]/20" />
                  )}
                  <span className="absolute top-3 left-3 rounded-full bg-[#0B1220]/70 border border-white/10 px-3 py-1 text-xs text-[#00FFB2]">{p.tag}</span>
                </div>
                <div className="p-6">
                  <h3 className="font-display text-lg font-semibold leading-snug">{p.title}</h3>
                  <p className="mt-2 text-sm text-white/55 line-clamp-2">{p.excerpt}</p>
                  <span className="mt-4 inline-flex items-center gap-1 text-sm text-[#00E5FF]">Read more <ArrowUpRight className="h-3.5 w-3.5" /></span>
                </div>
              </motion.button>
            </Reveal>
          ))}
        </div>
      </div>

      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent className="max-w-2xl bg-[#0B1220] border-white/10 text-white p-0 overflow-hidden max-h-[85vh] overflow-y-auto" data-testid="blog-modal">
          {open && (
            <div>
              <DialogTitle className="sr-only">{open.title}</DialogTitle>
              {open.image ? (
                <img src={open.image} alt={open.title} className="w-full aspect-[16/9] object-cover" />
              ) : (
                <div className="w-full aspect-[16/9] bg-gradient-to-br from-[#00E5FF]/20 to-[#7B61FF]/20" />
              )}
              <div className="p-7">
                <span className="rounded-full bg-[#00FFB2]/10 px-3 py-1 text-xs text-[#00FFB2]">{open.tag}</span>
                <h3 className="mt-4 font-display text-2xl font-bold">{open.title}</h3>
                <p className="mt-1 text-xs text-white/40">By {open.author}</p>
                <p className="mt-5 text-white/70 leading-relaxed">{open.content}</p>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
}
